export default __webpack_public_path__ + "media/zurb/img/party/world-domination-5ef010ad195c9a960a4f83ed3921bd42.png";